<!--
This file is used only in Vue3
Changes made here should be made in vue2 also
Vue2 File: ../../../../js/components/BannerOffers/SpecialOffer.vue
-->

<template>
  <div
    class="banners-safe-area specials-offer"
    :class="[designType, mobileLayoutClass, setBannerContentPosition(), bannerClasses]"
  >
    <div
      v-if="!ismobile"
      class="row justify-content-center specials-banner-content h-100 no-gutters"
      :class="[bannerdata.desktopLogoImageUrl ? 'offer-has-logo' : '']"
      :style="(setOfferPosition(bannerdata), setTextColor(bannerdata.textColor))"
    >
      <div
        class="offer-details-block align-self-center"
        :class="[bannerdata.offerBackgroundColor ? 'px-2 py-3' : '', paymentsColSpace]"
        :style="setBgcolor(bannerdata.offerBackgroundColor, bannerdata.offerBackgroundOpacity)"
      >
        <div v-if="bannerdata.offer.vehicleInfo" class="offer-vehicle-name pb-3">
          <p class="mb-0 text-uppercase info-year-type vehicle-type-label">
            New &nbsp;{{ vehicleYear }}
          </p>

          <p class="info-model font-weight-bold _theme_font_bold mb-0">
            <span :class="[isMazda ? 'text-uppercase' : '']">{{ vehicleMake }}</span>
            {{ vehicleModelTrimName }}
          </p>
          <p class="info-year-type font-weight-bold _theme_font_bold mb-0">
            {{ vehicleStyleWtBody }}
          </p>
        </div>
        <div class="offer-type-details">
          <div class="info-year-type text-uppercase payment-type-label">
            {{ bannerdata.offer.amountPreText }}
          </div>

          <div>
            <div
              class="offer-vehicle-price"
              v-html="formatOfferText1(bannerdata.offer.offerText1, bannerdata.enablePriceRoundOff)"
            />
          </div>
          <div class="info-year-type d-flex align-items-baseline">
            <div v-if="bannerdata.offer.offerText2" class="d-flex no-wrap">
              <span
                class="font-weight-bold _theme_font_bold"
                v-html="formatOfferGetTerm(bannerdata.offer.offerText2)"
              />
              <span class="text-uppercase vehicle-term-label">&nbsp;Months</span>
            </div>
            <div v-if="showOrSeparator" class="px-2 term-divider">|</div>
            <div
              class="d-inline-block offer-text3-label payment-details-info"
              v-html="offerText3"
            />
          </div>
        </div>
        <div
          v-if="displayPlayButton"
          class="info-year-type vdv-play d-flex align-items-center pt-1"
          @click.stop.prevent="playVDV(bannerdata)"
        >
          <em class="primaryicon-entertainment pr-2" />
          Play Video
        </div>
      </div>
      <div class="video-settings text-center desktop-video-settings" :class="[imageColSpace]">
        <div class="row no-gutters h-100">
          <div class="img-vdp-link" :class="[imgCol]">
            <evox-media-component
              v-if="bannerdata.offer.vehicleInfo && bannerdata.offer.vehicleInfo.styleID"
              :styleid="+bannerdata.offer.vehicleInfo.styleID"
              :imgurl="frameVehicleImgSrc(bannerdata)"
              :imgclass="'img-fluid'"
              :evoxmediastyles="
                ismobile
                  ? 'width: 100%;max-width: 350px;max-height: 100%;'
                  : 'width: 100%;max-width: 600px;max-height: 100%;'
              "
              :loop="
                bannerdata.enhancedAssetType &&
                bannerdata.enhancedAssetType.toLowerCase() === '360-spin'
                  ? true
                  : false
              "
              :animation-type="bannerdata.enhancedAssetType"
              :show-only-evox-image="true"
              class="set-relative-height"
            />
            <div class="vehicle-details_vdp d-flex justify-content-center">
              <div class="vdv_wrapper">
                <div class="text-center">
                  <a
                    class="cursor-pointer no-hover text-white bgcolor-primary font-weight-bold text-center d-inline-block px-3 py-2 ft-14 make-it-yours"
                    :style="[applyBannerButtonStyles(bannerdata)]"
                    @click.prevent="stopBubbling(bannerdata)"
                    >{{ bannerdata.ctaLabel ? bannerdata.ctaLabel : "Make It Yours" }}</a
                  >
                </div>
                <div
                  v-if="!disclaimerOnBanner"
                  class="d-lg-flex align-items-center ft-16 justify-content-center mt-3 vin-stock-wrapper"
                  :style="[vinStockSectionFontColor(bannerdata)]"
                >
                  <div v-if="bannerdata.offer && bannerdata.offer.vin">
                    <span class="text-uppercase vin-text">Vin#</span> {{ bannerdata.offer.vin }}
                  </div>
                  <div
                    v-if="bannerdata.offer && bannerdata.offer.stockNo"
                    class="text-uppercase stock-number"
                  >
                    Stock# {{ bannerdata.offer.stockNo }}
                  </div>
                  <div
                    class="cursor-pointer text-underline"
                    @click.prevent="openDisclaimer($event, bannerdata.offer.disclaimerText)"
                  >
                    {{ disclaimerLabel }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="showLogo(bannerdata)" class="col-3 logo-wrapper" :class="[logoCol]">
            <img
              :src="getLogoDimensions(bannerdata, 180)"
              alt="vehicle img"
              class="img-fluid logo-img"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="
        ismobile &&
        bannerdata.mobileImageSizeType &&
        bannerdata.mobileImageSizeType.toLowerCase() === 'medium'
      "
      class="specials-banner-content h-100"
      :class="[bannerdata.mobileLogoImageUrl ? 'offer-has-logo' : '']"
      :style="(setOfferPosition(bannerdata), setTextColor(bannerdata.textColor))"
    >
      <div class="row no-gutters align-items-center">
        <div class="col-7">
          <div
            :class="[bannerdata.offerBackgroundColor ? 'mm-bg-container' : '']"
            :style="setBgcolor(bannerdata.offerBackgroundColor, bannerdata.offerBackgroundOpacity)"
          >
            <div class="offer-details-block">
              <div v-if="bannerdata.offer.vehicleInfo" class="offer-vehicle-name">
                <p class="mb-0 text-uppercase info-year-type vehicle-type-label">
                  New &nbsp;{{ vehicleYear }}
                </p>
                <p class="info-model font-weight-bold _theme_font_bold mb-0">
                  {{ vehicleMake }}
                  {{ vehicleModelTrimName }}
                </p>
                <p class="info-year-type font-weight-bold _theme_font_bold mb-0">
                  {{ vehicleStyleWtBody }}
                </p>
              </div>
            </div>
            <div class="offer-type-details">
              <div class="info-year-type text-uppercase payment-type-label">
                {{ bannerdata.offer.amountPreText }}
              </div>

              <div>
                <div
                  class="offer-vehicle-price"
                  v-html="
                    formatOfferText1(bannerdata.offer.offerText1, bannerdata.enablePriceRoundOff)
                  "
                />
              </div>
              <div class="term-wrapper d-flex align-items-baseline">
                <div v-if="bannerdata.offer.offerText2" class="d-flex no-wrap">
                  <span
                    class="font-weight-bold _theme_font_bold"
                    v-html="formatOfferGetTerm(bannerdata.offer.offerText2)"
                  />
                  <span class="text-uppercase vehicle-term-label">&nbsp;Months</span>
                </div>
                <div v-if="showOrSeparator" class="px-1">|</div>
                <div class="d-inline-block payment-details-info" v-html="offerText3" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-5">
          <div v-if="showLogo(bannerdata)" class="logo-wrapper mb-1">
            <img
              :src="getLogoDimensions(bannerdata, 180)"
              alt="vehicle img"
              class="img-fluid logo-img"
            />
          </div>
          <evox-media-component
            v-if="bannerdata.offer.vehicleInfo && bannerdata.offer.vehicleInfo.styleID"
            :styleid="+bannerdata.offer.vehicleInfo.styleID"
            :imgurl="frameVehicleImgSrc(bannerdata)"
            :imgclass="'img-fluid'"
            :evoxmediastyles="
              ismobile
                ? 'width: 100%;max-width: 350px;max-height: 100%;'
                : 'width: 100%;max-width: 600px;max-height: 100%;'
            "
            :loop="
              bannerdata.enhancedAssetType &&
              bannerdata.enhancedAssetType.toLowerCase() === '360-spin'
                ? true
                : false
            "
            :animation-type="bannerdata.enhancedAssetType"
            :show-only-evox-image="true"
            class="set-relative-height"
          />
          <div
            v-if="displayPlayButton"
            class="info-year-type vdv-play d-flex align-items-center justify-content-center mt-2"
            @click.stop.prevent="playVDV(bannerdata)"
          >
            <em class="primaryicon-entertainment pr-2" />
            Play Video
          </div>
        </div>
      </div>
      <div class="vehicle-details_vdp mt-2">
        <div class="">
          <a
            class="cursor-pointer no-hover text-white bgcolor-primary font-weight-bold text-center d-inline-block px-3 py-2 ft-14 text-uppercase make-it-yours"
            :style="[applyBannerButtonStyles(bannerdata)]"
            @click.prevent="stopBubbling(bannerdata)"
            >{{ bannerdata.ctaLabel ? bannerdata.ctaLabel : "Make It Yours" }}</a
          >
        </div>
      </div>
      <div
        v-if="!disclaimerOnBanner"
        class="d-flex align-items-center ft-16 justify-content-left mt-2 vin-stock-wrapper"
        :style="[vinStockSectionFontColor(bannerdata)]"
      >
        <div v-if="bannerdata.offer && bannerdata.offer.vin">
          <span class="text-uppercase vin-text">Vin#</span> {{ bannerdata.offer.vin }}
        </div>
        <div
          v-if="bannerdata.offer && bannerdata.offer.stockNo"
          class="text-uppercase stock-number"
        >
          Stock# {{ bannerdata.offer.stockNo }}
        </div>
        <div
          class="cursor-pointer text-underline"
          @click.prevent="openDisclaimer($event, bannerdata.offer.disclaimerText)"
        >
          {{ disclaimerLabel }}
        </div>
      </div>
    </div>
    <div
      v-if="
        ismobile &&
        bannerdata.mobileImageSizeType &&
        bannerdata.mobileImageSizeType.toLowerCase() === 'large'
      "
      class="row specials-banner-content h-100 no-gutters"
      :class="[bannerdata.mobileLogoImageUrl ? 'offer-has-logo' : '']"
      :style="(setOfferPosition(bannerdata), setTextColor(bannerdata.textColor))"
    >
      <div class="col-12 offer-details-block">
        <div class="row no-gutters">
          <div class="col-9">
            <div
              :class="[bannerdata.offerBackgroundColor ? 'p-2' : '']"
              :style="
                setBgcolor(bannerdata.offerBackgroundColor, bannerdata.offerBackgroundOpacity)
              "
            >
              <div v-if="bannerdata.offer.vehicleInfo" class="offer-vehicle-name pb-2">
                <p class="mb-0 text-uppercase info-year-type vehicle-type-label">
                  New &nbsp;{{ vehicleYear }}
                </p>

                <p class="info-model font-weight-bold _theme_font_bold mb-0">
                  {{ vehicleMake }}
                  {{ vehicleModelTrimName }}
                </p>
                <p class="info-year-type font-weight-bold _theme_font_bold mb-0">
                  {{ vehicleStyleWtBody }}
                </p>
              </div>
              <div class="offer-type-details">
                <div class="info-year-type text-uppercase payment-type-label">
                  {{ bannerdata.offer.amountPreText }}
                </div>

                <div>
                  <div
                    class="offer-vehicle-price"
                    v-html="
                      formatOfferText1(bannerdata.offer.offerText1, bannerdata.enablePriceRoundOff)
                    "
                  />
                </div>
                <div class="term-wrapper d-flex align-items-baseline">
                  <div v-if="bannerdata.offer.offerText2" class="d-flex no-wrap">
                    <span
                      class="font-weight-bold _theme_font_bold"
                      v-html="formatOfferGetTerm(bannerdata.offer.offerText2)"
                    />
                    <span class="text-uppercase vehicle-term-label">&nbsp;Months</span>
                  </div>
                  <div v-if="showOrSeparator" class="px-1">|</div>
                  <div class="d-inline-block payment-details-info" v-html="offerText3" />
                </div>
              </div>
            </div>
          </div>
          <div v-if="showLogo(bannerdata)" class="col-3 logo-wrapper">
            <img
              :src="getLogoDimensions(bannerdata, 180)"
              alt="vehicle img"
              class="img-fluid logo-img"
            />
          </div>
        </div>
      </div>
      <div class="col-12 video-settings">
        <evox-media-component
          v-if="bannerdata.offer.vehicleInfo && bannerdata.offer.vehicleInfo.styleID"
          :styleid="+bannerdata.offer.vehicleInfo.styleID"
          :imgurl="frameVehicleImgSrc(bannerdata)"
          :imgclass="'img-fluid'"
          :evoxmediastyles="
            ismobile
              ? 'width: 100%;max-width: 350px;max-height: 100%;'
              : 'width: 100%;max-width: 600px;max-height: 100%;'
          "
          :loop="
            bannerdata.enhancedAssetType &&
            bannerdata.enhancedAssetType.toLowerCase() === '360-spin'
              ? true
              : false
          "
          :animation-type="bannerdata.enhancedAssetType"
          :show-only-evox-image="true"
          class="set-relative-height"
        />
        <div class="vehicle-details_vdp mt-2">
          <div
            class="text-center d-flex align-items-center justify-content-center"
            style="gap: 10px"
          >
            <a
              class="cursor-pointer no-hover text-white bgcolor-primary font-weight-bold text-center d-inline-block px-3 py-2 ft-14 text-uppercase make-it-yours"
              :style="[applyBannerButtonStyles(bannerdata)]"
              @click.prevent="stopBubbling(bannerdata)"
              >{{ bannerdata.ctaLabel ? bannerdata.ctaLabel : "Make It Yours" }}</a
            >
            <div
              v-if="displayPlayButton"
              class="info-year-type vdv-play d-flex align-items-center"
              @click.stop.prevent="playVDV(bannerdata)"
            >
              <em class="primaryicon-entertainment pr-2" />
              Play Video
            </div>
          </div>
          <div
            v-if="!disclaimerOnBanner"
            class="d-flex align-items-center ft-16 justify-content-center mt-2 vin-stock-wrapper"
            :style="[vinStockSectionFontColor(bannerdata)]"
          >
            <div v-if="bannerdata.offer && bannerdata.offer.vin">
              <span class="text-uppercase vin-text">Vin#</span> {{ bannerdata.offer.vin }}
            </div>
            <div
              v-if="bannerdata.offer && bannerdata.offer.stockNo"
              class="text-uppercase stock-number"
            >
              Stock# {{ bannerdata.offer.stockNo }}
            </div>
            <div
              class="cursor-pointer text-underline"
              @click.prevent="openDisclaimer($event, bannerdata.offer.disclaimerText)"
            >
              {{ disclaimerLabel }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="disclaimerOnBanner && bannerdata.offer.disclaimerText"
      class="disclaimer-on-banner text-justify"
      :style="setTextColor(bannerdata.textColor)"
    >
      <span>{{ displayBannerText }}</span>
      <span
        v-if="showReadMore"
        class="ml-1 read-more-text"
        @click.prevent="openDisclaimer($event, bannerdata.offer.disclaimerText)"
        >Read More...</span
      >
    </div>
  </div>
</template>

<script>
import EvoxMediaComponent from "@/js/components/EvoxMediaAssets/EvoxMediaComponent.vue";
import BannerOfferService from "../../../Services/BannerOfferService/BannerOfferService";
import { VEHICLE_TYPES } from "@/js/constants/constants";
import { onCommonLinkLogs } from "../../../Events/TagManagerServices/TaggingEventForPages";
import { hasDynamicBannerPlayButton } from "@/js/components/shared/VdvPanel/service/VdvService";
import { Events } from "../../../Events/ConsumerEvents/Events";
export default {
  components: {
    EvoxMediaComponent,
  },

  mixins: [BannerOfferService],
  props: {
    bannerdata: {
      required: true,
      default: null,
      type: Object,
    },
  },

  data() {
    return {
      disclaimerLabel: " Disclosure",
      showOrSeparator: false,
      vehicleModelTrimName: "",
      vehicleYear: "",
      vehicleMake: "",
      vehicleModel: "",
      vehicleTrim: "",
      offerText3: "",
    };
  },
  computed: {
    displayBannerText() {
      //check in mixin
      return this.getTrimmedDisclaimerText(this.bannerdata.offer.disclaimerText, this.bannerdata);
    },
    vehicleStyleWtBody() {
      return this.styleWithBodyType(this.bannerdata);
    },
  },
  created() {
    this.vehicleYear =
      this.bannerdata?.offer?.vehicleInfo.offerYear ||
      this.bannerdata?.offer?.vehicleInfo.modelYear;
    this.vehicleMake =
      this.bannerdata?.offer?.vehicleInfo.offerMake ||
      this.bannerdata?.offer?.vehicleInfo.divisionName;
    this.vehicleModel =
      this.bannerdata?.offer?.vehicleInfo.offerModel ||
      this.bannerdata?.offer?.vehicleInfo.modelName;
    this.vehicleTrim =
      this.bannerdata?.offer?.vehicleInfo.offerTrim || this.bannerdata?.offer?.vehicleInfo.trim;
    this.setModelTrimName();
  },
  mounted() {
    this.displayPlayButton = hasDynamicBannerPlayButton(this.bannerdata);
    this.showOrSeparator = this.bannerdata?.offer?.offerText2 && this.bannerdata?.offer?.offerText3;

    this.offerText3 = this.formatOfferText3(
      this.bannerdata?.offer?.offerText3,
      this.bannerdata.enablePriceRoundOff
    );
  },
  methods: {
    formatOfferText1(offerText, roundOff) {
      if (offerText && offerText.indexOf("$") >= 0) {
        let getValue = offerText.match(/(-\d+|\d+)(,\d+)*(\.\d+)*/g)
          ? offerText.match(/(-\d+|\d+)(,\d+)*(\.\d+)*/g)[0]
          : "";
        if (getValue) {
          let offerValue = (getValue + "").split(".")[0];
          let decimalValue = (getValue + "").split(".")[1];

          let valuePerLabel = offerText?.toLowerCase().replace(" ", "").includes("per day")
            ? "per day"
            : "per month";

          let roundOffOfferValue = getValue;

          if (typeof getValue === "string") {
            roundOffOfferValue = getValue.replace(/,/g, "");
          }
          roundOffOfferValue = Math.round(parseFloat(roundOffOfferValue));

          let htmlString = `<div>
                              <p class="mb-0 offer-price op-wrapper">
                                <span class="dollar-position font-weight-bold _theme_font_bold">$</span>
                                <span class="offer-price-text font-weight-bold _theme_font_bold">${this.convertToPriceFormat(
                                  roundOffOfferValue
                                )}</span>
                                <span class="info-year-type offer-price-label pl-1 pl-md-2 text-uppercase">${valuePerLabel}</span>
                              </p>
                            </div>`;
          if (!roundOff && decimalValue) {
            htmlString = `<div>
                            <p class="mb-0 offer-price op-wrapper">
                              <span class="dollar-position font-weight-bold _theme_font_bold">$</span>
                              <span class="offer-price-text font-weight-bold _theme_font_bold">${this.convertToPriceFormat(
                                offerValue
                              )}</span>
                              <span class="offer-price-decimals font-weight-bold _theme_font_bold">.${decimalValue}</span>
                              <span class="info-year-type offer-price-label text-uppercase">${valuePerLabel}</span>
                            </p>
                          </div>`;
          }
          return htmlString;
        }
      }
      return offerText;
    },
    formatOfferText3(offerText, roundOff) {
      //if offer is 0 or null i.e manual offer
      if (
        this.bannerdata?.offer?.paymentOffer === null ||
        this.bannerdata?.offer?.paymentOffer === 0
      ) {
        return `<span class="text-uppercase">${offerText || ""}</span>`;
      }

      if (offerText && offerText.indexOf("$") >= 0) {
        let getValue = offerText.match(/(-\d+|\d+)(,\d+)*(\.\d+)*/g)
          ? offerText.match(/(-\d+|\d+)(,\d+)*(\.\d+)*/g)[0]
          : "";
        if (getValue) {
          let valueAfterRoundOff = getValue;
          let offerLabel = offerText.slice(offerText.indexOf(getValue) + getValue.length);
          offerLabel = offerLabel ? offerLabel.trim().toLowerCase() : offerLabel;

          if (typeof getValue === "string") {
            valueAfterRoundOff = getValue.replace(/,/g, "");
          }
          valueAfterRoundOff = Math.round(parseFloat(valueAfterRoundOff));

          let htmlString = `<span class="font-weight-bold _theme_font_bold">$${this.convertToPriceFormat(
            valueAfterRoundOff
          )}</span>&nbsp;
                          <span class="text-uppercase">${offerLabel}</span>`;
          if (!roundOff) {
            htmlString = `<span class="font-weight-bold _theme_font_bold">$${this.convertToPriceFormat(
              getValue
            )}</span>&nbsp;
                            <span class="text-uppercase">${offerLabel}</span>`;
          }
          return htmlString;
        }
      }
      return offerText;
    },
    formatOfferGetTerm(offerText) {
      if (this.bannerdata?.offer?.paymentOffer === 1) {
        return this.bannerdata?.offer.term;
      } else if (offerText?.toLowerCase().indexOf("for") >= 0) {
        let getValue = offerText.match(/(-\d+|\d+)(,\d+)*(\.\d+)*/g)
          ? offerText.match(/(-\d+|\d+)(,\d+)*(\.\d+)*/g)[0]
          : "";
        if (getValue) {
          return `${getValue}`;
        }
      } else {
        return offerText;
      }
    },
    frameVehicleImgSrc(banner) {
      let styleId = banner.offer?.vehicleInfo?.styleID;
      let color = banner.color || banner.offer?.colorCode;
      let vehicleTypeId = banner.offer?.vehicleInfo?.vehicleTypeID;
      let vehicleTypeName = vehicleTypeId ? VEHICLE_TYPES[vehicleTypeId] : "SUV";
      let vin = banner.offer?.vin;

      let src = `https://service.secureoffersites.com/images/GetEvoxImage?styleid=${styleId}&edgecrop=true&angle=032`;

      if (vehicleTypeName && !src.includes("vehicletype")) {
        src = `${src}&vehicletype=${vehicleTypeName}`;
      }
      if (vin && !src.includes("vin")) {
        src = `${src}&vin=${vin}`;
      }

      if (color) {
        src = src + `&Colorcode=${color}`;
      }
      return src;
    },
    stopBubbling(bannerData) {
      let url = this.getVdpUrl(bannerData?.offer);
      setTimeout(() => {
        window.open(url, "_self");
      }, 200);
      try {
        onCommonLinkLogs({
          label: bannerData.ctaLabel ? bannerData.ctaLabel : "Make It Yours",
          url,
        });
      } catch (error) {
        console.log(error);
      }
    },
    getVdpUrl(bannerOffer) {
      let vdpUrl = bannerOffer.vdpUrl;
      if (bannerOffer?.vin && bannerOffer?.vdpUrl) {
        if (bannerOffer.offerType) {
          vdpUrl = !vdpUrl.includes("?")
            ? `${vdpUrl}?type=${bannerOffer.offerType}`
            : `${vdpUrl}&type=${bannerOffer.offerType}`;
        }
        if (bannerOffer.term) {
          vdpUrl = !vdpUrl.includes("?")
            ? `${vdpUrl}?term=${bannerOffer.term}`
            : `${vdpUrl}&term=${bannerOffer.term}`;
        }
      }
      return vdpUrl;
    },
    async playVDV(bannerData) {
      let url = this.getVdpUrl(bannerData?.offer || bannerData?.bannersPaymentHomenetVehicle);
      const vin = bannerData?.offer?.vin || bannerData?.bannersPaymentHomenetVehicle?.vin;
      let vehicleDetails = {};

      if (bannerData?.offer) {
        vehicleDetails = {
          vin,
          vehicleYear: this.vehicleYear,
          vehicleMake: this.vehicleMake,
          vehicleModel: this.vehicleModel,
          vehicleTrim: this.vehicleTrim,
        };
      } else if (bannerData?.bannersPaymentHomenetVehicle) {
        vehicleDetails = {
          vin,
          vehicleYear: bannerData?.bannersPaymentHomenetVehicle?.year,
          vehicleMake: bannerData?.bannersPaymentHomenetVehicle?.make,
          vehicleModel: bannerData?.bannersPaymentHomenetVehicle?.model,
          vehicleTrim: bannerData?.bannersPaymentHomenetVehicle?.trim,
        };
      }

      let eventmodel = {
        ...Events.consumerEventModel,
        consumerEventId: Events.eventsConstants.VdvBannerEvent,
        ...vehicleDetails,
      };

      await Events.logConsumerEvent(eventmodel);
      setTimeout(() => {
        window.open(`${url}#vdv`, "_self");
      }, 200);
    },
    setModelTrimName() {
      let trimValue = this.vehicleTrim?.split(" ").filter(Boolean) || [];
      let modelValue = this.vehicleModel?.split(" ").filter(Boolean) || [];
      let filteredTrim = trimValue.filter((trim) => !modelValue.includes(trim));
      this.vehicleModelTrimName =
        this.vehicleModel + (filteredTrim.length ? " " + filteredTrim.join(" ") : "");
    },
  },
};
</script>

<style>
.make-it-yours {
  text-transform: uppercase;
}
.specials-offer .specials-term-wrapper {
  font-size: 1.2em;
}
.specials-offer.medium_design .specials-term-wrapper {
  font-size: 1.4em;
}
.specials-offer.small_design .term-divider {
  padding: 0px 3px !important;
}
@media (min-width: 1400px) and (max-width: 1899px) {
  .specials-offer.medium_design .specials-term-wrapper {
    font-size: 1.6em;
  }
  .specials-offer.medium_design .specials-term-wrapper {
    font-size: 1.5em;
  }
}
@media (min-width: 1200px) and (max-width: 1399px) {
  .specials-offer .specials-term-wrapper {
    font-size: 1.8em;
  }
  .specials-offer.medium_design .specials-term-wrapper {
    font-size: 1.9em;
  }
  .specials-offer.small_design .specials-term-wrapper {
    font-size: 1.1em;
  }
}
@media (max-width: 767px) {
  .specials-offer.ml-size .specials-term-wrapper {
    font-size: 0.7em;
  }
  .specials-offer.mm-size .specials-term-wrapper {
    font-size: 10px;
  }
}
</style>
